"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("./styled-components");
var _card = _interopRequireDefault(require("../../atomic/card/card"));
var CardList = function CardList(_ref) {
  var items = _ref.items,
    css = _ref.css;
  return /*#__PURE__*/_react.default.createElement(_styledComponents.UnorderedList, {
    css: css
  }, items.map(function (_ref2) {
    var id = _ref2.id,
      content = _ref2.content,
      cardCss = _ref2.cardCss,
      badge = _ref2.badge,
      color = _ref2.color;
    return /*#__PURE__*/_react.default.createElement(_styledComponents.ListItem, {
      key: id
    }, /*#__PURE__*/_react.default.createElement(_card.default, {
      css: cardCss,
      badge: badge,
      color: color
    }, content));
  }));
};
CardList.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    content: _propTypes.default.element,
    cardCss: _propTypes.default.shape({}),
    badge: _propTypes.default.string,
    color: _propTypes.default.oneOf(['green', 'blue'])
  })).isRequired,
  css: _propTypes.default.shape({})
};
CardList.defaultProps = {
  css: {}
};
var _default = exports.default = CardList;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-select-plan-v2/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');